import { render, staticRenderFns } from "./AlarmMonitoring.vue?vue&type=template&id=56fce368&scoped=true"
import script from "./AlarmMonitoring.vue?vue&type=script&lang=js"
export * from "./AlarmMonitoring.vue?vue&type=script&lang=js"
import style0 from "./AlarmMonitoring.vue?vue&type=style&index=0&id=56fce368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fce368",
  null
  
)

export default component.exports